export default () => {
  const items = document.querySelectorAll('.js-mobile-dropdown-item')
  if (items.length < 1) return
  ;[...items].forEach(item => {
    const target = item.querySelector('.js-mobile-dropdown-target')

    item.addEventListener('click', e => {
      if (e.currentTarget === item) {
        target.classList.toggle('active')
        item.classList.toggle('active')
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/NavMobileDropdown.js